// reducers/test-maintenance/remove.js

export function removeHasErrored(state = false, action) {
  switch (action.type) {
    case 'U_REMOVE_TEST_M_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function removeIsLoading(state = false, action) {
  switch (action.type) {
    case 'U_REMOVE_TEST_M_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function remove(state = {}, action) {
  switch (action.type) {
    case 'U_REMOVE_TEST_M_FETCH_DATA_SUCCESS':
      return action.resp;
    default:
      return state;
  }
}